import * as React from 'react';
import { MainStyle } from '../assets/styles/MainStyle';
import { View,ScrollView, Image, Text, Linking} from 'react-native';
import ButtonComponent from '../components/ButtonComponent';
import NavBar from '../components/NavBar';
import pix_icon from '../assets/images/icons/pix.png';
import { getData } from '../services/StorageService';
import Clipboard from "@react-native-clipboard/clipboard";
import loading from '../assets/images/loading.gif';
import QRCode from "react-qr-code";
import {Navigate, NavigateParams} from '../services/Navigator';
import {checkPaymentPix} from '../services/ApiServices';

export default class PixPayment extends React.Component {
    constructor(props) {
        super(props);
        const styles = MainStyle();
        this.state = {
            redirect: {status: false, value: '/'},
            styles : styles,
            modalOpenend: false,
            systemColor: 'white',
            currentUrl: 'https://api.cartelas.app/api/v1/app"',
            params: null,
            variantbtn:"primary_filled",
            textbtn:"📋 Copiar código PIX...",
            checkInterval: null
        }
    }

    componentDidMount(){
        getData("current_url").then(res => {
            this.setState({currentUrl : res})
        })
        getData("props").then(res => {
            this.setState({params :  JSON.parse(res)})
        })
    
        getData("current_system_color").then(res => this.setState({systemColor : res}))

       // checkPayment();

    }

    handleModalOrder(){
        this.setState({modalOpenend : !this.state.modalOpenend})
    }

    
    checkPayment(){
        let interval = setInterval(() => {
            this.checkPaymentPix(this.state.currentUrl, this.state.params.order.paymentId).then(res => {
                if(res.status == true){
                    clearInterval(this.state.checkInterval)
                    this.setState({redirect : {status: true, value: 'Orders', params: {}}})
                }
            })
        },5000)
        this.setState({checkInterval : interval})
    }

    async setClipBoard(text){
        try {
            await navigator.clipboard.writeText(text);
            alert("Texto copiado para a área de transferência!");
        } catch (err) {
            console.error("Erro ao copiar: ", err);
        }
        
    }

    openURL = async (url) => {
          const supported = await Linking.canOpenURL(url);
          if (supported) {
            await Linking.openURL(url);
          } else {
            Alert.alert(`Don't know how to open this URL: ${url}`);
          }
      }

    render() {
        if(this.state.params == null){
            
        }
        else {
        return (
            <NavBar navigation={this.props.navigation}  >
                {this.state.redirect.status? <NavigateParams navigation={this.props.navigation} screen={this.state.redirect.value} params={this.state.redirect.params}></NavigateParams> : <Text></Text>}

                <View style={{height:40, ...this.state.styles.row, backgroundColor : this.state.systemColor, ...this.state.styles.justifyCenter, ...this.state.styles.alignCenter}}>
                    {/* <Image source={pix_icon} style={{width : 22, height: 22}} />  */}
                    <Text  style={{...this.state.styles.bold, ...this.state.styles.fs14, ...this.state.styles.cLight, marginLeft: 12}}>Pix copia e cola</Text>
                </View>

                             
                <View style={{width: '100%', paddingLeft: 8, paddingRight: 8, ...this.state.styles.col}}>
                    <View style={{width: '100%',...this.state.styles.row, ...this.state.styles.justifyCenter}}><Text style={{...this.state.styles.bold, ...this.state.styles.fs18, ...this.state.styles.cDark}}>PIX gerado com sucesso!</Text></View>
                    <ScrollView>
                        <View style={{...this.state.styles.mt8, width: '100%',  height: 128, ...this.state.styles.myShadow, ...this.state.styles.col}}>
                            <Text style={{marginLeft: 8,...this.state.styles.mt8,...this.state.styles.bold}}>{this.state.params.order.cartelas[0].data} - Pedido:{this.state.params.order.codigo} - Cartelas: {this.state.params.order.cartelas.length}</Text>
                            {this.state.params.order.cartelas.map(card => 
                                 <Text style={{marginLeft: 64,...this.state.styles.mt8,...this.state.styles.bold}}>Cartelas {card.codigo} ............ R${card.valor}</Text>
                            )}
                            <Text style={{marginLeft: 180,...this.state.styles.mt8,...this.state.styles.bold}}>Total: R${this.state.params.order.cartelas.length * parseFloat(this.state.params.order.cartelas[0].valor).toFixed(2)}</Text>    
                           
                        </View>
                    </ScrollView>
                    {/* <View style={{...this.state.styles.mt8, width: '100%',  height: 96, ...this.state.styles.myShadow, ...this.state.styles.col}}>
                            <Text style={{marginLeft: 8,...this.state.styles.mt8,...this.state.styles.bold}}>{this.state.params.order.codigoCopiaCola}</Text> 
                    </View> */}

                    <View style={{ height: "auto", margin: "0 auto", width: "100%", ...this.state.styles.row, ...this.state.styles.justifyCenter ,...this.state.styles.mt16}}>
                        <QRCode
                            size={256}
                            style={{ height: "auto", maxWidth: 256,  width: 256, ...this.state.styles.rounded, ...this.state.styles.borderSuccess }}
                            value={this.state.params.order.codigoCopiaCola}
                            viewBox={`0 0 256 256`}
                        />
                    </View>

                    <View style={{width: '100%', paddingLeft: 32, paddingRight: 32, ...this.state.styles.mt8, display: 'flex', flexDirection: 'row', ...this.state.styles.justifyCenter}}> <Image style={{width: 16, height: 16}} source={loading}></Image> <Text style={{...this.state.styles.fs14,...this.state.styles.bold , ...this.state.styles.cSecondary}}>Aguardando pagamento...</Text></View>
                    <View style={{width: '100%', paddingLeft: 32, paddingRight: 32, ...this.state.styles.mt8, ...this.state.styles.rounded , display: 'flex', flexDirection: 'row', ...this.state.styles.justifyCenter}}><Text style={{...this.state.styles.fs14,...this.state.styles.bold , ...this.state.styles.cSuccess}}>A aprovação leva no maximo 2 minutos!</Text></View>    
                    <View style={{width: '100%', ...this.state.styles.mt32}}>
                        <ButtonComponent disabled={false} action={() => {Clipboard.setString(this.state.params.order.codigoCopiaCola); this.setClipBoard(this.state.params.order.codigoCopiaCola); this.setState({variantbtn: "success_filled", textbtn: "Copiado com sucesso!"})}} variant={"light"}>{this.state.textbtn}</ButtonComponent>
                    </View>
                    <View style={{width: '100%', ...this.state.styles.mt8}}>
                        <ButtonComponent disabled={false} action={() => {this.openURL("https://cartelas.app")}} variant={"danger_filled"}>{"Já fiz o pagamento!"}</ButtonComponent>
                    </View>       
                </View>
            </NavBar>
            )
        }
    }
}
